import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  actions as detailTransactionActions,
  detailTransactionSelector,
} from "reducers/detailTransaction";
import {
  DetailTransactionCancelItemType,
  PayloadTransactionType,
  postDevolutionUndeliveredType,
} from "sagas/types/detailTransactions";
import { AppDispatch, RootState } from "store";
import { UndeliveredPropsType } from "./types";
import { ReasonList } from "../reasonList/ReasonList";
import {
  actions as transactionActions,
  transactionsSelector,
} from "reducers/transactions";
import { FilterTransactionsType } from "sagas/types/transactions";
import "../i18n";
import { useTranslation } from "react-i18next";
import { BackButton } from "../backButton/BackButton";

const Undelivered: React.FC<UndeliveredPropsType> = ({
  back,
  detailTransaction,
  messages,
  getMessages,
  selectedMessage,
  resetMessage,
  setMessageSelected,
  getDetailTransactionDevolutionUndelivered,
  getTransactions,
  filters,
  filtersExtra,
  isModalOpen,
}): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    if (isModalOpen) {
      resetMessage();
      getMessages({ id: detailTransaction.transaction.id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);
  const handleClick = (message: DetailTransactionCancelItemType) => {
    setMessageSelected(message);
  };
  return (
    <div className="container-finish">
      <BackButton back={back} />
      <div className="modal-transaction-scroll undelivered-container">
        <p className="modal-transaction-reasonsCanceled-subtitle">
          {t("detailTransaction:undeliveredReason")}
        </p>
        <ReasonList
          messages={messages}
          selectedMessage={selectedMessage}
          handleClick={handleClick}
        ></ReasonList>
        <div className="button-container-flex">
          <button
            onClick={() => {
              getDetailTransactionDevolutionUndelivered({
                id: detailTransaction.transaction.id,
                params: selectedMessage?.id,
                callBack: () => {
                  getTransactions({
                    ...filters,
                    offset: 0,
                  });
                },
              });
            }}
            disabled={selectedMessage === undefined}
            className="finish-button"
          >
            {t("detailTransaction:finish")}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  detailTransaction: detailTransactionSelector(state).detailTransaction,
  messages: detailTransactionSelector(state).messages,
  selectedMessage: detailTransactionSelector(state).messageSelected,
  filters: transactionsSelector(state).filters,
  isModalOpen: transactionsSelector(state).detailTransactionModalOpen,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getTransactions: (params: FilterTransactionsType) => {
    dispatch(transactionActions.getTransactionsRequest(params));
  },
  getMessages: (id: string) => {
    dispatch(detailTransactionActions.getDetailTransactionMenssagesRequest(id));
  },
  resetMessage: () => {
    dispatch(detailTransactionActions.getResetMessageDetailTransaccions());
  },
  setMessageSelected: (message: DetailTransactionCancelItemType) => {
    dispatch(detailTransactionActions.setMessageSelected(message));
  },
  getDetailTransactionDevolutionUndelivered: (
    params: PayloadTransactionType<postDevolutionUndeliveredType>
  ) => {
    dispatch(
      detailTransactionActions.getDetailTransactionDevolutionUndeliveredRequest(
        params
      )
    );
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Undelivered);
